import { useParams } from "react-router-dom"
import {
  FaBook,
  FaYoutube,
  FaFilePdf,
  FaUserGraduate,
  FaTools
} from "react-icons/fa"
import "./LMSCourseContent.css"
import Footer from "../Footer/Footer"
import Navbar from "../Navbar/Navbar"

const LMSCourseContent = () => {

  const lmsCourseContent = {
    "bsc-cs": {
      courseTitle: "B.Sc Computer Science",
      subjects: [
        {
          subjectId: "c-programming",
          subjectName: "Programming in C",
          faculty: "Dr.M.Vijay Kumar",
          topics: [
            {
              topicId: "intro-c",
              topicTitle: "Introduction to C",
              videos: [
                { title: "Introduction to C Language", url: "https://www.youtube.com/watch?v=example1" }
              ],
              materials: [
                { title: "C Basics Notes (PDF)", url: "/materials/bsc-cs/c/intro.pdf" }
              ]
            }
          ]
        }
      ]
    },
    "mca": {
  courseTitle: "Master of Computer Applications (M.C.A)",
  subjects: [
    {
      subjectId: "computer-organization",
      subjectName: "Computer Organization",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "co-intro",
          topicTitle: "Computer Organization – Fundamentals",
          videos: [
            {
              title: "Computer Organization Full Course",
              url: "https://www.youtube.com/live/zMkye9iaWB4?si=teysg4LlcYeF9WQ8"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "operating-system",
      subjectName: "Operating System",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "os-intro",
          topicTitle: "Operating System – Concepts",
          videos: [
            {
              title: "Operating System Full Course",
              url: "https://www.youtube.com/live/By6lWjiPpVI?si=qYzV_u2sL8D3tw0a"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "data-structures",
      subjectName: "Data Structures",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "ds-intro",
          topicTitle: "Data Structures – Fundamentals",
          videos: [
            {
              title: "Data Structures Full Course",
              url: "https://www.youtube.com/live/QBrDsG3MTkw?si=7OlR5i63P750dMjF"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "dbms",
      subjectName: "Database Management Systems",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "dbms-intro",
          topicTitle: "DBMS – Concepts and Design",
          videos: [
            {
              title: "DBMS Full Course",
              url: "https://www.youtube.com/live/khKoJUpcXUE?si=5mxaM-t_qbTz_Cr9"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "computer-networks",
      subjectName: "Computer Networks",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "cn-intro",
          topicTitle: "Computer Networks – Fundamentals",
          videos: [
            {
              title: "Computer Networks Full Course",
              url: "https://www.youtube.com/live/pGWxdTJPjKE?si=C_qaniEhsft_iDMK"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "machine-learning",
      subjectName: "Machine Learning",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "ml-intro",
          topicTitle: "Machine Learning – Introduction",
          videos: [
            {
              title: "Machine Learning Full Course",
              url: "https://youtu.be/gmvvaobm7eQ?si=Mt87FGIAO7xVjgqH"
            }
          ],
          materials: []
        }
      ]
    }
  ]
},
 "msc-cs": {
  courseTitle: "Master of Computer Applications (M.C.A)",
  subjects: [
    {
      subjectId: "computer-organization",
      subjectName: "Computer Organization",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "co-intro",
          topicTitle: "Computer Organization – Fundamentals",
          videos: [
            {
              title: "Computer Organization Full Course",
              url: "https://www.youtube.com/live/zMkye9iaWB4?si=teysg4LlcYeF9WQ8"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "operating-system",
      subjectName: "Operating System",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "os-intro",
          topicTitle: "Operating System – Concepts",
          videos: [
            {
              title: "Operating System Full Course",
              url: "https://www.youtube.com/live/By6lWjiPpVI?si=qYzV_u2sL8D3tw0a"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "data-structures",
      subjectName: "Data Structures",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "ds-intro",
          topicTitle: "Data Structures – Fundamentals",
          videos: [
            {
              title: "Data Structures Full Course",
              url: "https://www.youtube.com/live/QBrDsG3MTkw?si=7OlR5i63P750dMjF"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "dbms",
      subjectName: "Database Management Systems",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "dbms-intro",
          topicTitle: "DBMS – Concepts and Design",
          videos: [
            {
              title: "DBMS Full Course",
              url: "https://www.youtube.com/live/khKoJUpcXUE?si=5mxaM-t_qbTz_Cr9"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "computer-networks",
      subjectName: "Computer Networks",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "cn-intro",
          topicTitle: "Computer Networks – Fundamentals",
          videos: [
            {
              title: "Computer Networks Full Course",
              url: "https://www.youtube.com/live/pGWxdTJPjKE?si=C_qaniEhsft_iDMK"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "machine-learning",
      subjectName: "Machine Learning",
      faculty: "Dr.M.Vijay Kumar",
      topics: [
        {
          topicId: "ml-intro",
          topicTitle: "Machine Learning – Introduction",
          videos: [
            {
              title: "Machine Learning Full Course",
              url: "https://youtu.be/gmvvaobm7eQ?si=Mt87FGIAO7xVjgqH"
            }
          ],
          materials: []
        }
      ]
    }
  ]
},
 "btech-ai": {
  courseTitle: "Artificial Intelligence",
  subjects: [
    {
      subjectId: "computer-organization",
      subjectName: "Computer Organization",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "co-intro",
          topicTitle: "Computer Organization – Fundamentals",
          videos: [
            {
              title: "Computer Organization Full Course",
              url: "https://www.youtube.com/live/zMkye9iaWB4?si=teysg4LlcYeF9WQ8"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "operating-system",
      subjectName: "Operating System",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "os-intro",
          topicTitle: "Operating System – Concepts",
          videos: [
            {
              title: "Operating System Full Course",
              url: "https://www.youtube.com/live/By6lWjiPpVI?si=qYzV_u2sL8D3tw0a"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "data-structures",
      subjectName: "Data Structures",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "ds-intro",
          topicTitle: "Data Structures – Fundamentals",
          videos: [
            {
              title: "Data Structures Full Course",
              url: "https://www.youtube.com/live/QBrDsG3MTkw?si=7OlR5i63P750dMjF"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "dbms",
      subjectName: "Database Management Systems",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "dbms-intro",
          topicTitle: "DBMS – Concepts and Design",
          videos: [
            {
              title: "DBMS Full Course",
              url: "https://www.youtube.com/live/khKoJUpcXUE?si=5mxaM-t_qbTz_Cr9"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "computer-networks",
      subjectName: "Computer Networks",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "cn-intro",
          topicTitle: "Computer Networks – Fundamentals",
          videos: [
            {
              title: "Computer Networks Full Course",
              url: "https://www.youtube.com/live/pGWxdTJPjKE?si=C_qaniEhsft_iDMK"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "machine-learning",
      subjectName: "Machine Learning",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "ml-intro",
          topicTitle: "Machine Learning – Introduction",
          videos: [
            {
              title: "Machine Learning Full Course",
              url: "https://youtu.be/gmvvaobm7eQ?si=Mt87FGIAO7xVjgqH"
            }
          ],
          materials: []
        }
      ]
    }
  ]
},
"btech-cse": {
  courseTitle: "Computer Science and Engineering",
  subjects: [
    {
      subjectId: "computer-organization",
      subjectName: "Computer Organization",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "co-intro",
          topicTitle: "Computer Organization – Fundamentals",
          videos: [
            {
              title: "Computer Organization Full Course",
              url: "https://www.youtube.com/live/zMkye9iaWB4?si=teysg4LlcYeF9WQ8"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "operating-system",
      subjectName: "Operating System",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "os-intro",
          topicTitle: "Operating System – Concepts",
          videos: [
            {
              title: "Operating System Full Course",
              url: "https://www.youtube.com/live/By6lWjiPpVI?si=qYzV_u2sL8D3tw0a"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "data-structures",
      subjectName: "Data Structures",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "ds-intro",
          topicTitle: "Data Structures – Fundamentals",
          videos: [
            {
              title: "Data Structures Full Course",
              url: "https://www.youtube.com/live/QBrDsG3MTkw?si=7OlR5i63P750dMjF"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "dbms",
      subjectName: "Database Management Systems",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "dbms-intro",
          topicTitle: "DBMS – Concepts and Design",
          videos: [
            {
              title: "DBMS Full Course",
              url: "https://www.youtube.com/live/khKoJUpcXUE?si=5mxaM-t_qbTz_Cr9"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "computer-networks",
      subjectName: "Computer Networks",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "cn-intro",
          topicTitle: "Computer Networks – Fundamentals",
          videos: [
            {
              title: "Computer Networks Full Course",
              url: "https://www.youtube.com/live/pGWxdTJPjKE?si=C_qaniEhsft_iDMK"
            }
          ],
          materials: []
        }
      ]
    },

    {
      subjectId: "machine-learning",
      subjectName: "Machine Learning",
      faculty: "V.SATISH KUMAR",
      topics: [
        {
          topicId: "ml-intro",
          topicTitle: "Machine Learning – Introduction",
          videos: [
            {
              title: "Machine Learning Full Course",
              url: "https://youtu.be/gmvvaobm7eQ?si=Mt87FGIAO7xVjgqH"
            }
          ],
          materials: []
        }
      ]
    }
  ]
},


  }

  const { courseId } = useParams()
  const course = lmsCourseContent[courseId]

  return (
    <>
      <Navbar />

      {!course ? (
        <div className="lms-notready">
          <FaTools className="lms-notready-icon" />
          <h2>Course Content Under Preparation</h2>
          <p>Content will be uploaded soon by faculty members.</p>
        </div>
      ) : (
        <div className="lms-course-page">
          <div className="lms-course-header">
            <h1>{course.courseTitle}</h1>
          </div>

          {course.subjects.map(subject => (
            <div key={subject.subjectId} className="lms-subject">
              <h2>{subject.subjectName}</h2>
              <p className="lms-faculty">
                <FaUserGraduate /> {subject.faculty}
              </p>

              {subject.topics.map(topic => (
                <div key={topic.topicId} className="lms-topic">
                  <h3><FaBook /> {topic.topicTitle}</h3>

                  {topic.videos && (
                    <div className="lms-content-block">
                      <h4><FaYoutube /> Videos</h4>
                      <ul>
                        {topic.videos.map((v, i) => (
                          <li key={i}>
                            <a href={v.url} target="_blank" rel="noreferrer">{v.title}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {topic.materials && (
                    <div className="lms-content-block">
                      <h4><FaFilePdf /> Materials</h4>
                      <ul>
                        {topic.materials.map((m, i) => (
                          <li key={i}>
                            <a href={m.url} target="_blank" rel="noreferrer">{m.title}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      <Footer />
    </>
  )
}

export default LMSCourseContent
